var map = {
	"./STERiJECT_01.png": "f664",
	"./STERiJECT_02.png": "2326",
	"./STERiJECT_04.png": "d43b",
	"./STERiJECT_05.png": "e66d",
	"./STERiJECT_s2.png": "575a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce4f";